import { useFormStore } from "@/store/form";
import {
  getUuidStorageSession,
  setUuidStorageSession,
} from "@/utils/saleSessionStorage";
import { useEffect } from "react";
import { v4 as uuidV4 } from "uuid";

export function useJourneyUuid() {
  const form = useFormStore((store) => store.value);
  const addData = useFormStore((store) => store.addData);

  useEffect(() => {
    const uuidForm = form.uuid;
    if (uuidForm) {
      setUuidStorageSession(uuidForm);
    }

    if (!form.uuid) {
      const uuidStorageSession = getUuidStorageSession();
      if (uuidStorageSession) {
        addData({ uuid: JSON.parse(uuidStorageSession) });
      } else {
        const uuid = uuidV4();
        if (uuid) {
          setUuidStorageSession(uuid);
        }
        addData({ uuid });
      }
    }
  }, [addData, form]);

  return { uuid: form.uuid };
}
